import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { TextField, Button, IconButton, List, ListItem, ListItemText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../AuthContext';
import loadingGif from '../loading.gif';

const AllFAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [currentFAQ, setCurrentFAQ] = useState({ id: null, question: '', answer: '' });
  const { token } = useAuth();

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://sirius.runasp.net/api/FAQ', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFaqs(response.data);
    } catch (error) {
      console.error('There was an error fetching the FAQs!', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://sirius.runasp.net/api/FAQ/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 204) {
        setFaqs(faqs.filter(faq => faq.id !== id)); // Optimistically update the UI
        console.log('FAQ deleted successfully');
      } else {
        console.error('Error deleting FAQ:', response);
      }
    } catch (error) {
      console.error('There was an error deleting the FAQ!', error);
    }
  };

  const handleEdit = (faq) => {
    setEditMode(true);
    setCurrentFAQ(faq);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `https://sirius.runasp.net/api/FAQ/${currentFAQ.id}`,
        {
          question: currentFAQ.question,
          answer: currentFAQ.answer,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEditMode(false);
      setCurrentFAQ({ id: null, question: '', answer: '' });
      fetchFAQs(); // Refresh the list after update
    } catch (error) {
      console.error('There was an error updating the FAQ!', error);
    }
  };

  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..."  />
      </div>
    );
  }

  return (
    <div>
      <List>
        {faqs.map((faq) => (
          <ListItem key={faq.id}>
            <ListItemText primary={faq.question} secondary={faq.answer} />
            <IconButton onClick={() => handleEdit(faq)}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => handleDelete(faq.id)}>
              <DeleteIcon />
            </IconButton>
          </ListItem>
        ))}
      </List>

      {editMode && (
        <form onSubmit={handleUpdate}>
          <TextField
            label="Question"
            value={currentFAQ.question}
            onChange={(e) => setCurrentFAQ({ ...currentFAQ, question: e.target.value })}
            required
            style={{ margin: '5px' }}
          />
          <TextField
            label="Answer"
            value={currentFAQ.answer}
            onChange={(e) => setCurrentFAQ({ ...currentFAQ, answer: e.target.value })}
            required
            style={{ margin: '5px' }}
          />
          <Button style={{ margin: '15px 10px' }} type="submit" variant="contained" color="primary">
            Update FAQ
          </Button>
        </form>
      )}
    </div>
  );
};

export default AllFAQ;
